import React from "react";
import { getInitials, getRandomColor } from "./utils";

export interface AvatarProps {
  name?: string;
  src?: string;
  size?: number;
  shape?: "circle" | "square";
  backgroundColor?: string;
  textColor?: string;
  fontSize?: number;
  style?: React.CSSProperties;
}

const Avatar: React.FC<AvatarProps> = ({
  name = "User",
  src,
  size = 50,
  shape = "circle",
  backgroundColor,
  textColor = "#fff",
  fontSize = 18,
  style
}) => {
  const bgColor = backgroundColor || getRandomColor();
  const initials = getInitials(name);

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: shape === "circle" ? "50%" : "8px",
        backgroundColor: src ? "transparent" : bgColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: fontSize,
        color: textColor,
        fontWeight: "bold",
        overflow: "hidden",
        ...style
      }}
    >
      {src ? (
        <img
          src={src}
          alt={name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: shape === "circle" ? "50%" : "8px"
          }}
        />
      ) : (
        initials
      )}
    </div>
  );
};

export default Avatar;
